import { useState } from "react";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import Tooltip, { TooltipProps, tooltipClasses } from "@mui/material/Tooltip";
import { styled } from "@mui/material/styles";
import { ITooltipData } from "@Types/Contentful";
import Icon from "../../icon";
import classes from "./TinyPopper.module.scss";

const ButtonTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: theme.palette.common.white,
  },
  [`& .${tooltipClasses.tooltip}`]: {
    maxWidth: "20rem",
    fontSize: theme.typography.pxToRem(12),
    border: "1px solid #dadde9",
    color: "#26323d",
    boxShadow:
      "0 0 20px 4px rgb(154 161 177 / 15%), 0 4px 80px -8px rgb(36 40 47 / 25%), 0 4px 4px -2px rgb(91 94 105 / 15%)",
    backgroundColor: "#fff",
  },
}));

interface ITinyPopperProps {
  tooltipData: ITooltipData;
}
export default function TinyPopper(props: ITinyPopperProps) {
  const { title, description, example } = props?.tooltipData ?? {
    title: "",
    description: "",
    example: "",
  };
  const [showTooltip, setShowTooltip] = useState(false);

  const handleTooltipClose = () => {
    setShowTooltip(false);
  };

  const handleTooltipOpen = () => {
    setShowTooltip(true);
  };

  return (
    <ClickAwayListener
      onClickAway={handleTooltipClose}
      data-testid="button-close"
    >
      <span className={classes["product-tile__price-estimate"]}>
        <ButtonTooltip
          arrow
          placement="top"
          PopperProps={{
            disablePortal: true,
          }}
          onClose={handleTooltipClose}
          open={showTooltip}
          disableFocusListener
          disableHoverListener
          disableTouchListener
          title={
            <div>
              <div className={classes["price-estimate-notice"]}>
                <h3 className={classes["price-estimate-notice__title"]}>
                  {title}
                </h3>
                <p className={classes["price-estimate-notice__body"]}>
                  {description}
                  <br />
                  <strong>{example}</strong>
                </p>
              </div>
            </div>
          }
        >
          <button
            type="button"
            aria-label="price estimate trigger button"
            className={classes["product-tile__price-estimate-trigger"]}
            data-testid="button-open"
            aria-describedby="tippy-1"
            onClick={handleTooltipOpen}
          >
            <Icon iconName="question" />
          </button>
        </ButtonTooltip>
      </span>
    </ClickAwayListener>
  );
}
